"use client";
import React, { useState } from "react";
import { useTranslation } from "@/src/i18n/client";
import stl from "./productImgSwiper.module.scss";

interface IProps {}
const ShowSliderGuideClient: React.FC<React.PropsWithChildren<IProps>> = (
    props,
) => {
    const { t } = useTranslation("productDetail");
    const [isShowSliderGuide, setIsShowSliderGuide] = useState(false); //是否显示引导图

    const guideClick = (e: any) => {
        e.stopPropagation();
        setIsShowSliderGuide(false);
    };
    return (
        isShowSliderGuide && (
            <div className={stl["guide"]} onClick={guideClick}>
                {props.children}
                <p>{t("productDetail:SwipeGuide")}</p>
            </div>
        )
    );
};

export default ShowSliderGuideClient;
